import { Facebook, LinkedIn, Telegram } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import React from "react";
import MainLayout from "./MainLayout";

const company = {
  name: "Orbit Technology Solutions.",
  tagline: "Turn Ideas Into Reality.",
  website: "https://www.orbit.et",
  contactEmail: "ceo@orbit.et",
  phone: "0963626061",
  logo: "/orbit.png", // Add your logo path here
  socialLinks: [
    {
      name: "Facebook",
      url: "https://web.facebook.com/p/Orbit-Technology-Solution-PLC-100086330515097?_rdc=1&_rdr",
      icon: <Facebook />,
    },
    {
      name: "Telegram",
      url: "https://www.t.me/orbitet",
      icon: <Telegram />,
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/orbitet",
      icon: <LinkedIn />,
    },
  ],
};

const DeveloperCompanyProfile = () => {
  return (
    <MainLayout>
      <Grid container spacing={2} justifyContent="center" sx={{ padding: 3 }}>
        <Grid item xs={12} md={8}>
          <Card variant="outlined">
            <CardContent>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                <Grid item>
                  <img
                    src={company.logo}
                    alt={company.name}
                    style={{ width: "200px" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h4" align="center" gutterBottom>
                    {company.name}
                  </Typography>
                  <Typography variant="h6" align="center" gutterBottom>
                    {company.tagline}
                  </Typography>
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 0.5,
                  my: 3
                }}
              >
                <Box sx={{ width: "fit-content" }}>
                  <Typography variant="body1" paragraph>
                    <strong>Website:</strong>
                    <Link
                      href={company.website}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {company.website}
                    </Link>
                  </Typography>
                  <Typography variant="body1" paragraph>
                    <strong>Contact Email:</strong>
                    <Link href={`mailto:${company.contactEmail}`}>
                      {company.contactEmail}
                    </Link>
                  </Typography>
                  <Typography variant="body1" paragraph>
                    <strong>Phone Number:</strong> {company.phone}
                  </Typography>
                </Box>
              </Box>

              {company.socialLinks.length > 0 && (
                <div>
                  <Typography variant="h6" gutterBottom align="center">
                    Social Media Links
                  </Typography>
                  <Grid container justifyContent="center" spacing={2}>
                    {company.socialLinks.map((link, index) => (
                      <Grid item key={index}>
                        <IconButton
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {link.icon}
                        </IconButton>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default DeveloperCompanyProfile;
